export enum LocalStorageKey {
  /** @knipignore Not sure why this is marked as unused */
  DRAFT_EDITOR_PANELS = "draftEditorPanels",

  PREVIEW_RESPONSIVE_SIZE = "previewResponsiveSize",

  EDITOR_PREVIEW_SCROLL_SYNC = "editorPreviewScrollSync",
}
